export enum SaleType {
  PrivateTreatySale = 1,
  SingleVendorAuction = 2,
  MultiVendorAuction = 3,
  AllSemenCatalogue = 4,
  MultiVendorPrivateTreatySale = 5,
}
